import instance from "../../../api";
import {RequestResponse} from "../../../types";

export const sendCode = async (body): Promise<RequestResponse> => {
  return await instance(false)
    .post("/auth/send_code/", body)
    .then((res) => res?.data);
};